// import { GetAppIcon } from '@material-ui/icons';
import './Download.css'
import GetAppIcon from '@material-ui/icons/GetApp';
import logo from '../res/img/AMO_Logo.png';

function Download(){

    const manuals = [
        {link:"/res/manual/register-v2.pdf", title:"ขั้นตอนการดาวน์โหลดและลงทะเบียนแอปพลิเคชั่น AMO"},
        {link:"/res/manual/mobile-manual.pdf", title:"คู่มือการใช้งานแอปพลิเคชั่น AMO สำหรับ มือถือ"},
        {link:"/res/manual/center-manual.pdf", title:"คู่มือการใช้งานแอปพลิเคชั่น AMO สำหรับ ศูนย์ควบคุม"},
        {link:"/res/manual/faq-v2.pdf", title:"ปัญหาการใช้งานที่พบบ่อย"}
    ]

    return(
        <div class="container">
            <div>
                <div class="logo">
                    <img class="img-fluid" src={logo}/>
                </div>
                <div>
                    <h2 class="amo-name">Advanced Military Operations</h2>
                </div>
                <div class="input">
                </div>

                <hr class="hr-download"/>
                <div>
                    <ul class="manual">
                        {
                            manuals.map((el) => {
                                return (
                                    <li>
                                        <GetAppIcon style={{ color: "white",  verticalAlign: "middle"}}/>
                                        <a href={el.link}>{el.title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}



export default Download;